import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router';
import { api } from '../models/api-client.js';
import { useSession } from './session-context.jsx';

export function useLogout() {
  const { setUser } = useSession();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => api('/api/logout', { method: 'POST' }),
    onSuccess: () => {
      queryClient.clear();
      setUser(false);
      navigate('/');
    },
  });
}
